import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from '../../utils';
import { debugWarn } from '../../utils/log';

export const COMPONENT_NAME = 'SearchDraftManager';

class SearchDraftManager extends Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
        search: PropTypes.string,
        onSearchSubmit: PropTypes.func,
    };

    static defaultProps = {
        search: '',
        onSearchSubmit: noop,
    };

    state = {
        search: this.props.search,
        prevSearch: this.props.search,
    };

    static getDerivedStateFromProps (props, state) {
        if (props.search !== state.prevSearch) {
            return {
                search: props.search,
                prevSearch: props.search,
            };
        }
        return null;
    }

    onSearchSubmit = () => {
        this.props.onSearchSubmit(this.state.search);
    };

    onSearchClear = () => {
        this.props.onSearchSubmit('');
    };

    onSearchChange = (search) => this.setState({ search });

    render () {
        const { children: renderTable } = this.props;
        const { search } = this.state;
        if (typeof renderTable !== 'function' || React.isValidElement(renderTable)) {
            debugWarn(`Unexpected non-function children in ${COMPONENT_NAME}:`, renderTable);
        }
        return renderTable({
            searchable: true,
            search,
            onSearchSubmit: this.onSearchSubmit,
            onSearchClear: this.onSearchClear,
            onSearchChange: this.onSearchChange,
        });
    }
}

export default SearchDraftManager;
